const articles = [
  {
    slug: "what-is-worship",
    name: "What is worship?",
    description: "A biblical look at worship and why it reaches beyond music.",
    bodyPath: "/articles/what-is-worship.txt",
  },
  {
    slug: "are-we-required-to-sing-at-church",
    name: "Are we required to sing at church?",
    description:
      "A study on why congregational singing matters when the church gathers.",
  },
];

export default articles;
